<template>
    
    <div class='carousel-container'>
        
        <!-- Carousel Slides -->
        <div
            v-for="slide in carouselData" 
            class='slide'
            :key="slide.id"
        >

            <div style="width: 100%; max-height: 800px">

                <!-- Desktop -->
                <a 
                    v-if="slide.imageLink"
                    :href="slide.imageLink"
                >

                    <img 
                        :src="slide.imageUrl"
                        :alt="slide.imageAlt" 
                        class="my-slide-desktop"
                        style="width: 100%; max-height: 800px"
                    >

                </a>

                <!-- If no Link is Provided for Desktop -->
                <img 
                    v-else
                    :src="slide.imageUrl"
                    :alt="slide.imageAlt" 
                    class="my-slide-desktop"
                    style="width: 100%; max-height: 600px"
                >

                <!-- Mobile -->
                <a 
                    v-if="slide.imageLinkMobile"
                    :href="slide.imageLinkMobile"
                >

                    <img 
                        :src="slide.imageUrlMobile"
                        :alt="slide.imageAltMobile" 
                        class="my-slide-mobile"
                        style="width: 100%; max-height: 800px"
                    >

                </a>

                <!-- If no Link is Provided for Mobile -->
                <img 
                    v-else
                    :src="slide.imageUrlMobile"
                    :alt="slide.imageAltMobile" 
                    class="my-slide-mobile"
                    style="width: 100%; max-height: 600px"
                >

            </div>

        </div>

    </div>

</template>

<script>

    export default {

        props:["carouselData"],

    }

</script>

<style scoped>

    .carousel-container {
        position: relative;
        overflow: hidden;
        flex-direction: column;
        align-items: center;
    }

    .carousel {
        display: flex;
        justify-content: center;
    }

    .slide {
        flex: 0 0 100%;
        width: 100%;
        max-height: 800px;
        transition: transform 0.5s ease-in-out;
    }

    /* Media Queries for Images */
     @media only screen and (max-width: 700px) {

        .my-slide-desktop { display: none; }
        .my-slide-mobile { display: block; }

    }

    @media only screen and (min-width: 700px) {

        .my-slide-desktop { display: block; }
        .my-slide-mobile { display: none; }

    }


</style>